import { render } from "./TissuTypeList.vue?vue&type=template&id=7514a474"
import script from "./TissuTypeList.vue?vue&type=script&lang=js"
export * from "./TissuTypeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__